/**
 * Smooth in-page anchor links that also move keyboard focus.
 *
 * Theme link settings can't hold a bare "#id", so buttons link to
 * "/pages/your-page#id". When that path is the current page, scroll to the
 * target instead of reloading, then focus the first field inside it (e.g. the
 * Klaviyo email input) so keyboard and screen reader users land where sighted
 * users do. Targets come from section "Anchor ID" settings (see sections/apps.liquid).
 */
(function () {
  "use strict";

  var FOCUSABLE = 'input:not([type="hidden"]):not([disabled]), select, textarea, button, a[href]';

  function samePage(link) {
    return link.origin === location.origin && link.pathname === location.pathname && link.hash.length > 1;
  }

  document.addEventListener("click", function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var link = e.target.closest("a[href]");
    if (!link || !samePage(link)) return;

    var target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
    if (!target) return;

    e.preventDefault();

    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
    history.pushState(null, "", link.hash);

    var field = target.querySelector(FOCUSABLE);
    if (!field) {
      target.setAttribute("tabindex", "-1");
      field = target;
    }
    field.focus({ preventScroll: true });
  });
})();
